import React from "react";
import { ChlCardIcon } from "../../Admin/Checklist/ChlCardIcon";
import "./ChartBox.scss";

// Card de gráfico de dashboard — título (con ícono + pill de año opcional)
// y contenido como dos rectángulos blancos separados, mismo patrón que ya
// usa el Dashboard de Checklist (.cldash__chart-title-bar / __chart-content).
// Va siempre dentro de un contenedor gris (ver .gen-dash__chart-slot).
export function ChartBox({ title, pill, children }) {
  return (
    <div className="chart-box">
      <div className="chart-box__title-bar">
        <div className="chart-box__title"><ChlCardIcon />{title}</div>
        {pill && <span className="chart-box__year-pill">{pill}</span>}
      </div>
      <div className="chart-box__content">{children}</div>
    </div>
  );
}
